<div class="card card-box mb-5">
  <div class="card-header py-3">
    <div class="card-header--title font-size-lg">
      <b><i class="fas fa-cog"></i> Users </b>
    </div>
    <div class="card-header--actions">
      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">
                <span class="btn-wrapper--icon">
                    <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>
                </span>
        <span class="btn-wrapper--label">
                    New User
                </span>
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-between px-4 py-3">
    <div class="search-wrapper">
          <span class="icon-wrapper text-black">
            <fa-icon [icon]="['fas', 'search']"></fa-icon>
          </span>
      <input class="form-control form-control-sm rounded-pill" placeholder="Search terms..." type="search">
    </div>
  </div>
  <div class="divider"></div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap mb-0">
      <thead>
      <tr>
        <th class="bg-white text-center">ID</th>
        <th class="bg-white text-center">USER NAME</th>
        <th class="bg-white text-center">NAME</th>
        <th class="bg-white text-center">STATUS</th>
        <th class="bg-white text-center">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let pac of packages">
        <td class="font-weight-bold text-center">
          # {{pac.id}}
        </td>
        <td class="font-weight-bold text-center">
          {{pac.username}}
        </td>
        <td class="text-center">
          <span style="font-size: 15px" class="badge bg-neutral-danger text-danger">
            {{pac.fullName}}
          </span>
        </td>

        <td class="text-center">
          <span  class="badge m-1 badge-success">Active</span>

        </td>

        <td class="text-center">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <!--            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>-->
            <button type="button" class="btn btn-danger" (click)="packageDelete('errorModal',pac.id)"><i
              class="far fa-trash-alt"></i></button>
            <button type="button" class="btn btn-success" (click)="packageUpdate(pac.id)" ><i class="fas fa-check-circle"></i></button>
          </div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
  <div class="card-footer py-3 d-flex justify-content-between">

  </div>
</div>
<!--===========================Add Model===================================-->

<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"
     role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Create new user</h6>
        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">

          <form [formGroup]="packForm">
            <input formControlName="" class="form-control mb-2" placeholder="User Name" type="text">
            <input formControlName="" class="form-control mb-2" placeholder="Full Name" type="text">
            <input formControlName="" class="form-control mb-2" placeholder="Email" type="text">
            <input formControlName="" class="form-control mb-2" placeholder="Mobile" type="text">

          </form>


        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>
        <!--        <button type="button" class="btn btn-primary ml-auto" (click)="addModal.hide()">Save changes</button>-->
        <button class="btn btn-success ladda-button ml-auto" data-style="slide-up"
                [ladda]="isLoading" (click)="createPackage()">
          <span class="ladda-label"> Proceed </span>
          <span class="ladda-spinner"></span>
          <div class="ladda-progress" style="width: 0px;"></div>
        </button>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
